import { DistanceUnit } from '../store/mst/models';
import formatNumber from './formatNumber';

const getKmsOrMiles = (
  distance: number,
  distanceUnit: DistanceUnit,
): string => {
  const formattedDistance = formatNumber(distance);
  if (distanceUnit === DistanceUnit.KM) {
    return `${formattedDistance} km`;
  }

  return `${formattedDistance} mi`;
};

export default getKmsOrMiles;
